"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Integration_module_css_1 = __importDefault(require("../../Integration.module.css"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_i18next_1 = require("react-i18next");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var types_1 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("@/Components/common/AccessControl"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_components_2 = require("@nordicscreen/q-play-components");
var q_play_core_2 = require("@nordicscreen/q-play-core");
var LiveResourceScriptAccordion_1 = __importDefault(require("./LiveResourceScriptAccordion"));
var ResourceScriptAccordion_1 = __importDefault(require("./ResourceScriptAccordion"));
var AppIntegrationHelper_1 = __importDefault(require("@/Components/AppIntegration/AppIntegrationHelper"));
var inertia_1 = require("@inertiajs/inertia");
var IntegrationHelper_1 = __importDefault(require("@/Helper/IntegrationHelper"));
var TypeGuards_1 = require("@/functions/TypeGuards");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var IntegrationSettingsTab = function (props) {
    var _a, _b, _c, _d;
    var logger = q_play_core_1.logManager.getLogger();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _e = (0, react_1.useState)(undefined), localSettingsData = _e[0], setLocalSettingsData = _e[1];
    var _f = (0, react_1.useState)(false), expandedAccordion = _f[0], setExpandedAccordion = _f[1];
    var _g = (0, react_1.useState)(false), saveError = _g[0], setSaveError = _g[1];
    (0, react_1.useEffect)(function () {
        var newData = buildSettingsData();
        if (newData) {
            setLocalSettingsData(newData);
        }
    }, [props.integration, props.integrationTemplate]);
    var buildSettingsData = function () {
        var _a;
        if (props.integration) {
            q_play_core_2.RuleManager.paidLevel = (_a = props.integration.paid_level) !== null && _a !== void 0 ? _a : 0;
            var data = {
                template_id: props.integration.template_id,
                // todo: find a way to make the name unique (?)
                name: props.integration.name,
                version: props.integration.version,
                secrets: {},
                setup: props.integration.definition.setup,
                resources: {},
                scripts: {}
            };
            if (props.integration.definition.scripts) {
                for (var identifier in props.integration.definition.scripts) {
                    data.scripts[identifier] = JSON.parse(JSON.stringify(props.integration.definition.scripts[identifier]));
                }
            }
            if (props.integration.definition.resources) {
                var resources = props.integration.definition.resources;
                for (var identifier in resources) {
                    data.scripts[identifier] = JSON.parse(JSON.stringify(resources[identifier]));
                }
            }
            return data;
        }
        if (props.integrationTemplate) {
            var data_1 = {
                template_id: props.integrationTemplate.id,
                name: props.integrationTemplate.name,
                version: "".concat(props.integrationTemplate.current_version, ".").concat(props.integrationTemplate.current_patch_version),
                secrets: {},
                setup: {
                    variables: {}
                },
                resources: {},
                scripts: {}
            };
            props.integrationTemplate.definition.script.settings.forEach(function (setting) {
                if (!setting)
                    return;
                var defaultValue = setting.getDefaultValue();
                if (defaultValue !== undefined) {
                    data_1.setup.variables[setting.key] = defaultValue;
                }
            });
            return data_1;
        }
        return undefined;
    };
    var onNameSettingsChangedHandler = function (event) {
        if (!localSettingsData)
            return;
        var updated = __assign(__assign({}, localSettingsData), { name: event.target.value });
        setLocalSettingsData(updated);
    };
    var onSettingsChangedHandler = function (e, key) {
        var _a, _b;
        if (!localSettingsData || !((_b = (_a = props.integrationTemplate) === null || _a === void 0 ? void 0 : _a.definition) === null || _b === void 0 ? void 0 : _b.script.settings))
            return;
        var data_value;
        var propKey;
        var setting;
        if (key) {
            propKey = key;
            setting = props.integrationTemplate.definition.script.settings.find(function (setting) { return setting.key === propKey; });
            data_value = e;
        }
        else {
            var event_1 = e;
            propKey = event_1.target.dataset.key;
            setting = props.integrationTemplate.definition.script.settings.find(function (setting) { return setting.key === propKey; });
            if (setting instanceof q_play_core_1.BooleanSetting) {
                data_value = event_1.target.checked;
            }
            else {
                data_value = event_1.target.value;
            }
        }
        if (!setting)
            return;
        var updatedVariables = __assign({}, localSettingsData.setup.variables);
        if (setting instanceof q_play_core_1.BooleanSetting) {
            updatedVariables[propKey] = data_value;
        }
        else {
            var value = setting.hydrate(data_value);
            if ((0, TypeGuards_1.isPrimitive)(value))
                updatedVariables[propKey] = value;
        }
        setLocalSettingsData(__assign(__assign({}, localSettingsData), { setup: { variables: updatedVariables } }));
    };
    var onCredentialsChangedHandler = function (e, key) {
        var _a;
        var _b, _c;
        if (!localSettingsData || !((_c = (_b = props.integrationTemplate) === null || _b === void 0 ? void 0 : _b.definition) === null || _c === void 0 ? void 0 : _c.script.settings))
            return;
        var data_value;
        var propKey;
        var setting;
        if (key) {
            propKey = key;
            setting = props.integrationTemplate.definition.script.settings.find(function (setting) { return setting.key === propKey; });
            data_value = e;
        }
        else {
            var event_2 = e;
            propKey = event_2.target.dataset.key;
            setting = props.integrationTemplate.definition.script.settings.find(function (setting) { return setting.key === propKey; });
            if (setting instanceof q_play_core_1.BooleanSetting) {
                data_value = event_2.target.checked;
            }
            else {
                data_value = event_2.target.value;
            }
        }
        if (!setting)
            return;
        var updatedSecrets = __assign(__assign({}, localSettingsData.secrets), (_a = {}, _a[propKey] = String(setting.hydrate(data_value)), _a));
        setLocalSettingsData(__assign(__assign({}, localSettingsData), { secrets: updatedSecrets }));
    };
    var onScriptResourceChangedHandler = function (identifier, data) {
        var _a;
        if (!localSettingsData)
            return;
        if (Object.keys(data).length === 0) {
            var updatedScripts = __assign({}, localSettingsData.scripts);
            delete updatedScripts[identifier];
            setLocalSettingsData(__assign(__assign({}, localSettingsData), { scripts: updatedScripts }));
        }
        else {
            var updatedScripts = __assign(__assign({}, localSettingsData.scripts), (_a = {}, _a[identifier] = data, _a));
            setLocalSettingsData(__assign(__assign({}, localSettingsData), { scripts: updatedScripts }));
        }
    };
    var handleAccordionChange = function (panel) { return function (event, isExpanded) {
        setExpandedAccordion(isExpanded ? panel : false);
    }; };
    var handleDeleteResource = function (identifier) { return __awaiter(void 0, void 0, void 0, function () {
        var isScriptSaved, dataProvider, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isScriptSaved = props.integration &&
                        props.integration.definition &&
                        props.integration.definition.scripts &&
                        identifier in props.integration.definition.scripts;
                    if (!isScriptSaved) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    dataProvider = (0, AjaxProvider_1.default)("/api");
                    return [4 /*yield*/, dataProvider.deleteResource(props.integration.id, identifier)];
                case 2:
                    _a.sent();
                    if (props.onResourceDelete) {
                        props.onResourceDelete(identifier);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Failed to delete resource:", error_1);
                    return [2 /*return*/];
                case 4:
                    onScriptResourceChangedHandler(identifier, {});
                    return [2 /*return*/];
            }
        });
    }); };
    var addScriptHandler = function () {
        if (!localSettingsData)
            return;
        var prefix = "script-";
        var maxNum = 0;
        Object.keys(localSettingsData.scripts).forEach(function (key) {
            if (!key.startsWith(prefix))
                return;
            var suffix = key.slice(prefix.length);
            var num = parseInt(suffix, 10);
            if (!isNaN(num)) {
                maxNum = Math.max(maxNum, num);
            }
        });
        var identifier = "".concat(prefix).concat(maxNum + 1);
        localSettingsData.scripts[identifier] = {
            template: "",
            name: t("New script"),
            variables: {}
        };
        setLocalSettingsData(__assign({}, localSettingsData));
        setExpandedAccordion(identifier);
    };
    var saveIntegration = function () { return __awaiter(void 0, void 0, void 0, function () {
        var integration;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!localSettingsData)
                        return [2 /*return*/];
                    if (!props.integration) return [3 /*break*/, 3];
                    return [4 /*yield*/, IntegrationHelper_1.default.update(props.integration.id, localSettingsData)];
                case 1:
                    integration = _b.sent();
                    return [4 /*yield*/, AppIntegrationHelper_1.default.updateAppIntegration(props.integration.id, localSettingsData)];
                case 2:
                    integration = _b.sent();
                    if (!integration) {
                        setSaveError(t("Unable to save integration"));
                    }
                    else if (props.onIntegrationUpdate) {
                        props.onIntegrationUpdate(integration);
                        setLocalSettingsData(buildSettingsData());
                    }
                    return [3 /*break*/, 5];
                case 3:
                    localSettingsData.version = (_a = props.integrationTemplate.definition) === null || _a === void 0 ? void 0 : _a.script.version;
                    return [4 /*yield*/, AppIntegrationHelper_1.default.createAppIntegration(localSettingsData)];
                case 4:
                    integration = _b.sent();
                    if (!integration) {
                        setSaveError(t("Unable to save integration"));
                    }
                    inertia_1.Inertia.visit("/integration/manage/".concat(integration.id));
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var integrationName = new q_play_core_1.StringSetting("integration-name", t("Name"));
    var primaryColumnSettings = (_a = props.integrationTemplate) === null || _a === void 0 ? void 0 : _a.definition.script.settings.filter(function (setting) {
        var _a;
        return setting &&
            setting.section !== "secondary" &&
            setting.section !== "credentials" &&
            setting.isVisible((_a = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.setup.variables) !== null && _a !== void 0 ? _a : {});
    });
    var secondaryColumnSettings = (_b = props.integrationTemplate) === null || _b === void 0 ? void 0 : _b.definition.script.settings.filter(function (setting) { var _a; return setting && setting.section === "secondary" && setting.isVisible((_a = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.setup.variables) !== null && _a !== void 0 ? _a : {}); });
    var credentialColumnSettings = (_c = props.integrationTemplate) === null || _c === void 0 ? void 0 : _c.definition.script.settings.filter(function (setting) { var _a; return setting && setting.section === "credentials" && setting.isVisible((_a = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.setup.variables) !== null && _a !== void 0 ? _a : {}); });
    var liveResources = [];
    Object.keys(props.integrationTemplate.definition.script.scripts).map(function (key) {
        if (props.integrationTemplate.definition.script.scripts[key].schedule.type === "live") {
            liveResources.push(props.integrationTemplate.definition.script.scripts[key]);
        }
    });
    var globalSettingsLayout = {
        default: { width: "35%" },
        secondary: { width: "35%" },
        credentials: undefined
    };
    if (credentialColumnSettings && credentialColumnSettings.length > 0) {
        globalSettingsLayout.credentials = { width: "30%" };
    }
    else {
        integrationName.layout = "wide";
        globalSettingsLayout.default.width = "65%";
    }
    if (!props.integrationTemplate) {
        return null;
    }
    return (react_1.default.createElement("div", { className: Integration_module_css_1.default["integration-editor"] },
        react_1.default.createElement("div", { className: Integration_module_css_1.default["title"], style: { margin: "0 0 0 -5px" } },
            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } }, props.integrationTemplate.name)),
        react_1.default.createElement("div", { className: Integration_module_css_1.default["header"], style: { margin: "0 0 0 -5px" } },
            react_1.default.createElement("div", { className: Integration_module_css_1.default["description-panel"] },
                props.integrationTemplate.description,
                props.integrationTemplate.description_link && (react_1.default.createElement("div", { style: { marginTop: "15px" } },
                    react_1.default.createElement("a", { href: props.integrationTemplate.description_link, style: { color: "#507C7D" }, target: "_blank", rel: "noopener noreferrer" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faGlobe, style: {
                                color: "#507C7D",
                                width: "15px",
                                height: "15px",
                                marginRight: "10px"
                            } }),
                        t("Read more about the integration")))))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: types_1.ResourceType.INTEGRATION },
                react_1.default.createElement("div", { className: Integration_module_css_1.default["ns-page-card"] },
                    react_1.default.createElement("div", { key: "integration-editor", style: { display: "flex", justifyContent: "space-between", gap: "25px" } },
                        react_1.default.createElement("div", { key: "global-primary-section", style: { width: globalSettingsLayout.default.width } },
                            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                                t("Global settings"),
                                ":"),
                            react_1.default.createElement("div", { key: "global-primary-section", className: Integration_module_css_1.default["variable-editor"] },
                                react_1.default.createElement(q_play_components_2.SettingsComponent, { key: integrationName.key, value: (_d = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.name) !== null && _d !== void 0 ? _d : "", disabled: false, setting: integrationName, onChange: onNameSettingsChangedHandler }), primaryColumnSettings === null || primaryColumnSettings === void 0 ? void 0 :
                                primaryColumnSettings.map(function (setting) {
                                    var _a, _b;
                                    return (react_1.default.createElement(q_play_components_2.SettingsComponent, { key: setting.key, value: (_a = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.setup.variables[setting.key]) !== null && _a !== void 0 ? _a : "", disabled: setting.isDisabled((_b = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.setup.variables) !== null && _b !== void 0 ? _b : {}), setting: setting, onChange: onSettingsChangedHandler }));
                                }))),
                        globalSettingsLayout.secondary && (react_1.default.createElement("div", { style: { width: globalSettingsLayout.secondary.width } },
                            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { marginBottom: "10px" } }, "\u00A0"),
                            react_1.default.createElement("div", { key: "global-secondary-section", className: Integration_module_css_1.default["variable-editor"] }, secondaryColumnSettings === null || secondaryColumnSettings === void 0 ? void 0 : secondaryColumnSettings.map(function (setting) {
                                var _a, _b;
                                return (react_1.default.createElement(q_play_components_2.SettingsComponent, { key: setting.key, value: (_a = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.setup.variables[setting.key]) !== null && _a !== void 0 ? _a : "", disabled: setting.isDisabled((_b = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.setup.variables) !== null && _b !== void 0 ? _b : {}), setting: setting, onChange: onSettingsChangedHandler }));
                            })))),
                        globalSettingsLayout.credentials && (react_1.default.createElement("div", { style: { width: globalSettingsLayout.credentials.width } }, (credentialColumnSettings === null || credentialColumnSettings === void 0 ? void 0 : credentialColumnSettings.length) ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                                t("Credentials"),
                                ":"),
                            react_1.default.createElement("div", { key: "global-credentials-section", className: Integration_module_css_1.default["variable-editor"] }, credentialColumnSettings.map(function (setting) {
                                var _a, _b, _c;
                                return (react_1.default.createElement(q_play_components_2.SettingsComponent, { key: setting.key, value: setting.secret
                                        ? (_a = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.secrets[setting.key]) !== null && _a !== void 0 ? _a : ""
                                        : (_b = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.setup.variables[setting.key]) !== null && _b !== void 0 ? _b : "", disabled: setting.isDisabled((_c = localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.setup.variables) !== null && _c !== void 0 ? _c : {}), setting: setting, onChange: setting.secret
                                        ? onCredentialsChangedHandler
                                        : onSettingsChangedHandler }));
                            })))) : null))))),
            liveResources.length > 0 && (react_1.default.createElement("div", { className: Integration_module_css_1.default["ns-page-card"] },
                react_1.default.createElement("div", { style: { width: "100%" } },
                    react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" }, title: t("Scripts generating resources live") },
                        t("Live scripts"),
                        ":"),
                    react_1.default.createElement("div", { className: Integration_module_css_1.default["scripts-accordion-wrapper"], "data-cy": "integrationScriptList" }, liveResources.map(function (script) {
                        var isExpanded = expandedAccordion === script.identifier;
                        return (react_1.default.createElement(LiveResourceScriptAccordion_1.default, { key: script.identifier, identifier: script.identifier, integrationTemplate: props.integrationTemplate, resourceScriptTemplate: props.integrationTemplate.definition.script.scripts[script.identifier], expanded: isExpanded, resourceEditorData: localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.scripts[script.identifier], onChange: handleAccordionChange(script.identifier), onScriptResourceChangedHandler: onScriptResourceChangedHandler }));
                    }))))),
            props.integration && (react_1.default.createElement("div", { className: Integration_module_css_1.default["ns-page-card"] },
                react_1.default.createElement("div", { style: { width: "100%" } },
                    react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                        t("Scheduled scripts"),
                        ":"),
                    react_1.default.createElement("div", { className: Integration_module_css_1.default["scripts-accordion-wrapper"], "data-cy": "integrationScriptList", style: Object.keys((localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.scripts) || {}).length < 1
                            ? { maxWidth: "98%" }
                            : {} }, Object.keys((localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.scripts) || {}).map(function (identifier) {
                        var isExpanded = expandedAccordion === identifier;
                        return (react_1.default.createElement("div", { key: identifier, style: { display: "flex", alignItems: "center" } },
                            react_1.default.createElement(ResourceScriptAccordion_1.default, { identifier: identifier, integrationTemplate: props.integrationTemplate, expanded: isExpanded, resourceEditorData: localSettingsData === null || localSettingsData === void 0 ? void 0 : localSettingsData.scripts[identifier], onChange: handleAccordionChange(identifier), onScriptResourceChangedHandler: onScriptResourceChangedHandler, integrationId: props.integration.id }),
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, style: {
                                    cursor: "pointer",
                                    color: "var(--info-color)",
                                    marginLeft: "10px",
                                }, onClick: function () { return handleDeleteResource(identifier); } })));
                    })),
                    react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: types_1.ResourceType.INTEGRATION },
                        react_1.default.createElement(q_play_components_1.Button, { variant: "primary", size: "normal", className: "d-flex justify-content-center align-items-center p-0 mt-3", onClick: addScriptHandler, style: { position: "relative", top: "-6px", width: "100%" }, dataCy: "integrationAddResourceButton" },
                            react_1.default.createElement("span", { className: "d-flex justify-content-center align-items-center", style: { height: "40px" } }, "+"))))))),
        react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: types_1.ResourceType.INTEGRATION },
            react_1.default.createElement("div", { style: { margin: "20px -10px", display: "flex", justifyContent: "space-between" } },
                react_1.default.createElement("div", null, saveError && react_1.default.createElement("span", { style: { color: "var(--error-color)" } }, saveError)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), onClick: saveIntegration, "data-cy": "saveIntegrationButton" }))))));
};
exports.default = IntegrationSettingsTab;
